import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { RouteReuseStrategy } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxIndexedDBModule } from 'ngx-indexed-db';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as SentrySibling from '@sentry/angular';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth/auth.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { ComponentsModule } from './components/components.module';
import { RegistrationComponent } from './auth/registration/registration.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { dbConfig } from './db-description';
import { AuthInterceptor } from './utils/interceptors/auth.interceptor';
import { ErrorInterceptor } from './utils/interceptors/error.interceptor';
import { BackupService } from './services/backup.service';
import { VersionService } from './services/version.service';
import { SentryInitService } from './services/sentry-init.service';
import { UserAgreementComponent } from './auth/registration/user-agreement/user-agreement.component';
import { DataProcessingTermsComponent } from './auth/registration/data-processing-terms/data-processing-terms.component';
import { FileService } from './services/file.service';

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    RegistrationComponent,
    UserAgreementComponent,
    DataProcessingTermsComponent,
    ForgotPasswordComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    ComponentsModule,
    BrowserAnimationsModule,
    NgxIndexedDBModule.forRoot(dbConfig)
  ],
  providers: [
    VersionService,
    BackupService,
    FileService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useValue: SentrySibling.createErrorHandler()
    },
    SentryInitService,
    {
      provide: APP_INITIALIZER,
      useFactory: (initializer: SentryInitService) => () =>
        initializer.initSentry(),
      deps: [SentryInitService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
